
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as uses6BanvxVx_vwqI1XfgoF1X1WH3FJAZhWc2TECP7fAJNsMeta } from "/app/app/pages/uses.vue?macro=true";
import { default as aboutrGPy1pFPB0rYqvDyz4_9NXlT_DouL8moWyegH9oDWz4Meta } from "/app/app/pages/about.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as contact9YIjszO30YiI1EF3Yrjj3j04hZuaoJnKFtoCHkd82XkMeta } from "/app/app/pages/contact.vue?macro=true";
import { default as index8Z_8rtAjW2jgWQ_OJYTXT5HwpUt6Sq_SlrDHEXRGPb8Meta } from "/app/app/pages/lab/index.vue?macro=true";
import { default as indexv2yp_toDb5EUK8ku_QAWpOo627WINk_K3_nAWa_ufBUMeta } from "/app/app/pages/blog/index.vue?macro=true";
import { default as _91slug_93Mno9BhJAdIXJNhWcz__6_VIpaqzjKgImkktyOWcnxesMeta } from "/app/app/pages/lab/[slug].vue?macro=true";
import { default as _91slug_933j3aB90NQpbcgM9m38rZZJF0c2jXm3_tW_8yP_2rP7YMeta } from "/app/app/pages/blog/[slug].vue?macro=true";
import { default as indexF8bvp5HrlTJlXXmaha1p4uwFSHKo_aLDWW3ukAFWyowMeta } from "/app/app/pages/projects/index.vue?macro=true";
import { default as _91slug_93hDybkkQtoa_gato_7RKYEmA5kYw4OI4am8w4je6SGPUMeta } from "/app/app/pages/projects/[slug].vue?macro=true";
export default [
  {
    name: "uses",
    path: "/uses",
    component: () => import("/app/app/pages/uses.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/app/pages/contact.vue")
  },
  {
    name: "lab",
    path: "/lab",
    component: () => import("/app/app/pages/lab/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "lab-slug",
    path: "/lab/:slug()",
    component: () => import("/app/app/pages/lab/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/app/pages/blog/[slug].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/app/app/pages/projects/index.vue")
  },
  {
    name: "projects-slug",
    path: "/projects/:slug()",
    component: () => import("/app/app/pages/projects/[slug].vue")
  }
]